// extracted by mini-css-extract-plugin
export default {"questionContainer":"question-slide_questionContainer__3JmZa","question":"question-slide_question__RoVKq"};